const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
import { parseCustomFieldSearchParams } from '@/common/zod-schemas/common/filters';
import { itemFilterUrlSearchSchema } from '@/common/zod-schemas/itemFilterUrlSearchSchema';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
// `teamId` is no longer declared separately here — it's folded into the shared
// itemFilterUrlSearchSchema below, so a team-scoped portfolio link and an ad-hoc
// team filter applied from the toolbar are the same URL param, not two competing ones.
const portfolioSearchSchema = itemFilterUrlSearchSchema.extend({
  ...itemPanelSearchSchema.shape,
  // Reserved for follow-up saved-views/recommendation work; validated but unused for now.
  filterSetId: z.string().optional(),
  fromRecommendation: z.string().optional(),
  selectAll: z.preprocess((v: unknown) => v === 'true' || v === true, z.boolean().optional()).optional(),
  createInstance: z.string().optional(),
  oauthCredentialsId: z.number().optional(),
  loopId: z.number().optional(),
  callbackSource: z.string().optional()
});
type PortfolioBeforeLoadArgs = {
  context: {
    permissions: Partial<PermissionsResponseDTO>;
    flags: {
      enableCombinedPortfolioAndVisualizationsTab: boolean;
    };
  };
};
export const portfolioBeforeLoad = async (args: PortfolioBeforeLoadArgs) => {
  if (!args.context.flags.enableCombinedPortfolioAndVisualizationsTab) {
    await requirePermission('edit_planner')(args);
    return;
  }
  await requirePermission('view_loop_visualization')(args);
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>) => ({
    ...portfolioSearchSchema.parse(search),
    ...parseCustomFieldSearchParams(search)
  }),
  beforeLoad: portfolioBeforeLoad,
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.portfolio)
    }
  }
});